import script from "./TheRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./TheRoom.vue?vue&type=script&setup=true&lang=js"

import "./TheRoom.vue?vue&type=style&index=0&id=4e883e9a&scoped=true&lang=scss"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e883e9a"]])

export default __exports__